import { render } from "./batchAccountClosureCY.vue?vue&type=template&id=1dabbb72&scoped=true"
import script from "./batchAccountClosureCY.vue?vue&type=script&lang=js"
export * from "./batchAccountClosureCY.vue?vue&type=script&lang=js"

import "./batchAccountClosureCY.vue?vue&type=style&index=0&id=1dabbb72&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1dabbb72"

export default script